import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';

/**
 * Generated class for the ChooseroaddirectionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-chooseroaddirection',
  templateUrl: 'chooseroaddirection.html',
})
export class ChooseroaddirectionPage {
  obj: any
  seldriver: any
  radioDirection: any;
  vehicleid: any


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
    this.obj = this.navParams.get('obj');
    this.obj.unshift({ id: 0, clientid: this.gn.user.ClientId, patenbroj: 0, brojackomesto: 0, patenpravec: this.gn.dic.l["NoneRoadDirection"] })
    this.seldriver = this.navParams.get('seldriver');
    this.vehicleid = this.navParams.get('vid');

    if (this.seldriver != '/' || undefined) {
      for (let i = 0; i < this.obj.length; i++) {
        if (this.seldriver + '' == this.obj[i].patenpravec + '') {
          this.radioDirection = this.obj[i].id
        }
      }
    }
    else {
      this.radioDirection = 0
    }
    this.resetSearch()
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChooseroaddirectionPage');
  }

  resetSearch() {
    for (var i = 0; i < this.obj.length; i++) {
      this.obj[i].Visible = true
    }
  }

  getItems(ev: any) {
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchClients(val);
  }


  searchClients(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this.obj.length; i++) {
        if (this.gn._latcyr(this.obj[i].patenpravec.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.obj[i].patenpravec.toLowerCase()).indexOf(val) > -1) {
          this.obj[i].Visible = true
        } else {
          this.obj[i].Visible = false
        }
      }
    }
    else {
      this.resetSearch()
    }
  }

  ionViewDidLeave() {
    var cb = this.navParams.get('cb')
    var _that = this
    _that.gn._Post('/api/gn/setvehicleroaddirection', { vid: _that.gn.crypt(_that.vehicleid), rdid: _that.gn.crypt(_that.radioDirection) }, function (_data2) {
      cb(_that.radioDirection)
    });
  }




}



// WEBPACK FOOTER //
// ./src/pages/chooseroaddirection/chooseroaddirection.ts